import React from 'react';
import Button from '../Button/Button';
import { useChannelToggle } from './hooks/useChannelToggle';
import { CHANNEL_TYPES } from '../../constants';
import Loader from '../../components/Loader/Loader';
import { Link } from '@reach/router';

export const ChannelingToggleSwitcher = () => {
  const [status, toggles, updateToggleStatus, draftsAvailable] = useChannelToggle();

  const toggleList = toggles.map((toggle, index) => {
    const { status } = toggle;
    const channelTypeName = (CHANNEL_TYPES[toggle.channel_type] || toggle.channel_type).toLowerCase();

    return (
      <Button
        key={index}
        type={status ? 'green' : 'red' }
        className="h-8 b-1-currentColor"
        onClick={() => updateToggleStatus(toggle)}
      >
        {status ? 'Re-activate' : 'Deactivate'} {channelTypeName}
      </Button>
    );
  });

  if (status === 'idle') return null;

  if (status === 'rejected') {
    return 'Error fetching the channels';
  }
  
  return (
    <Loader inline loading={status === 'pending'}>
      <div className="channeling_toggles">
        {toggleList}
        {
          draftsAvailable ?
            <Link to="/channeling/changeset">
              <Button type="blue" className="h-8">
                Review Drafts
              </Button>
            </Link>
          : null
        }
      </div>
    </Loader>
  )
}
